import { Component } from '@angular/core';

@Component({
  selector: 'brt-animation-card',
  templateUrl: './animation-card.component.html',
  styleUrls: ['./animation-card.component.scss']
})
export class AnimationCardComponent {

}
